import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ICivilStatusCommonDomain } from '../interface/ICivilStatusCommonDomain';
import { ISideMenuJsonDto } from '../interface/ISideMenuJsonDto';

enum CommonDomainServiceEnum {
	getAll = '/',
	edit = '/',
	save = '/',
	delete = '/',
	diligenceQuestionsJson = '/diligence-questions-json/',
	attorneyJson = '/attorney-json',
	getCourt = '/get-court',
	getBankList = '/get-bank/',
	getDomainByCode = '/get-domain-by-code/',
	getCivilStatus = '/get-civil-status',
	appVersion = '/app-version'
}

export default class CommonDomainService extends ApiService {
	constructor(restClient: AxiosInstance) {
		super(restClient, '/common-domain');
	}

	public getAll = async () => await this.GET(CommonDomainServiceEnum.getAll);
	public edit = async data => await this.PUT(CommonDomainServiceEnum.edit, data);
	public save = async data => await this.POST(CommonDomainServiceEnum.save, data);
	public delete = async data => await this.DELETE(CommonDomainServiceEnum.delete, data);
	public getDiligenceQuestionJson = async domain => await this.GET(CommonDomainServiceEnum.diligenceQuestionsJson + domain);
	public getAttorneyJson = async () => await this.GET(CommonDomainServiceEnum.attorneyJson);
	public getBankList = async (): Promise<any> => await this.GET(CommonDomainServiceEnum.getBankList);
	public getCivilStatus = async (): Promise<ICivilStatusCommonDomain> => await this.GET(CommonDomainServiceEnum.getCivilStatus);
	public getDomainByCode = async (code): Promise<any> => await this.GET(CommonDomainServiceEnum.getDomainByCode + code);
	public getSideMenuByCode = async (): Promise<ISideMenuJsonDto> => await this.GET(CommonDomainServiceEnum.getDomainByCode + "side-menu-json"); // ISideMenuJsonDto
}



// WEBPACK FOOTER //
// ./src/services/api/CommonDomain.service.ts